export default __webpack_public_path__ + "static/media/ADA.d8584c91.png";